import {
  PAGE_LOADING,
  PAGE_LOADED,
  ANALYTICS_POPULATE,
  SELECT_LOCATIONS,
  SELECT_DATES,
  GET_TRENDING_DATA,
  GET_METRIC_LIST,
  UPDATE_TOP_ITEMS,
  UPDATE_LOWEST_ITEMS,
  INVENTORY_POPULATE
} from "../../constants/types";
import axios from "axios";
import store from '../../store'
import { toggleLowItem, toggleTopItem } from "../salesLoader";


export const requestInventoryData = () => {
  return (dispatch, getState)=>{
    return new Promise((resolve, reject) => {
      const { filters } = getState().analytics;
      const locations = getState().selectedLocations;
      axios
        .get("api/inventory/", {
          params: {
            locations,
            end_date: filters.selectedDate.end_date,
            type: "oscar_dashboard"
          }
        })
        .then(response => {
          dispatch({
            type: INVENTORY_POPULATE,
            payload: response.data
          });
        });
    });
  
  }
};




// WEBPACK FOOTER //
// ./src/modules/inventory/InventoryActions.js